/* PV drawer cross-sell 达标A (s247 r2, Codex-fixed) — cart-aware "You may also like" in side cart.
   Persistent (loaded once in theme.liquid), survives ajax_side_cart re-render.
   Cards built via DOM API (no attr-injection). Reuses full-page filter (Codex-verified s246).
   [源: research/redesign/cart-drawer-xsell-build-plan-2026-06-14.md + codex review a101e7faec40] */
(function(){
  function money(c){try{if(window.Shopify&&Shopify.formatMoney&&window.theme&&theme.moneyFormat){return Shopify.formatMoney(c,theme.moneyFormat);}}catch(e){}return '$'+(c/100).toFixed(2);}
  function card(p){
    var li=document.createElement('li'); li.className='pv-xsell-card';
    var a=document.createElement('a'); a.className='pv-xsell-card__link'; a.href=p.url||'#';
    var md=document.createElement('div'); md.className='pv-xsell-card__media';
    var img=p.featured_image; if(img&&img.indexOf('//')===0){img='https:'+img;}
    if(img){var im=document.createElement('img'); im.src=img; im.alt=p.title||''; im.loading='lazy'; md.appendChild(im);}
    var t=document.createElement('div'); t.className='pv-xsell-card__title'; t.textContent=p.title||'';
    var pr=document.createElement('div'); pr.className='pv-xsell-card__price'; pr.textContent=money(p.price);
    a.appendChild(md); a.appendChild(t); a.appendChild(pr); li.appendChild(a); return li;
  }
  function fill(root){
    if(!root||root.hasAttribute('data-pv-filled')) return;
    root.setAttribute('data-pv-filled','1');
    var seed=root.getAttribute('data-seed'); if(!seed||seed==='0') return;
    var anc=parseInt(root.getAttribute('data-anchor'),10)||0,
        lo=parseFloat(root.getAttribute('data-lo'))||0.5,
        hi=parseFloat(root.getAttribute('data-hi'))||2.0,
        keep=parseInt(root.getAttribute('data-keep'),10)||4,
        inc=(root.getAttribute('data-incart')||'').split(',').filter(Boolean),
        stags=(function(){try{var a=JSON.parse(root.getAttribute('data-seed-tags')||'[]');return Array.isArray(a)?a:[];}catch(e){return [];}})(),
        recs=root.querySelector('[data-xsell-recs]'), fb=root.querySelector('[data-xsell-fallback]');
    if(!recs) return;
    fetch('/recommendations/products.json?product_id='+encodeURIComponent(seed)+'&intent=related&limit=10',{headers:{Accept:'application/json'}})
      .then(function(x){return x.ok?x.json():null;})
      .then(function(d){
        if(!d||!d.products) return;
        var out=[];
        d.products.forEach(function(p){
          if(out.length>=keep) return;
          if(inc.indexOf(String(p.id))!==-1) return;             // (1) exclude in-cart
          if(!p.available||!p.featured_image) return;            // (4) in-stock + image
          if(typeof p.price!=='number'||!isFinite(p.price)) return; // (nit) reject non-numeric price (no $NaN)
          if(anc>0 && (p.price<anc*lo || p.price>anc*hi)) return; // (2) price band
          if(stags.length && !(p.tags||[]).some(function(t){return stags.indexOf(t)!==-1;})) return; // (3) same-category
          out.push(p);
        });
        if(out.length<3) return;  // <3 -> keep fallback
        var frag=document.createDocumentFragment();
        out.forEach(function(p){frag.appendChild(card(p));});
        recs.innerHTML=''; recs.appendChild(frag); recs.hidden=false; if(fb){fb.hidden=true;}
      })
      .catch(function(){});
  }
  function scan(){var n=document.querySelectorAll('[data-pv-drawer-xsell]:not([data-pv-filled])');for(var i=0;i<n.length;i++){fill(n[i]);}}
  if(document.readyState!=='loading'){scan();}
  document.addEventListener('DOMContentLoaded',scan);
  document.addEventListener('cart-update',function(){setTimeout(scan,60);});
  try{var host=document.getElementById('halo-cart-sidebar')||document.body;if(host){new MutationObserver(function(){scan();}).observe(host,{childList:true,subtree:true});}}catch(e){}
})();
